import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _dec, _class, _CourseDetailsHeader;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import CourseDetailsHeader from '../CourseDetailsHeader/CourseDetailsHeader';
import Discussions from '../../../components/Discussions/Discussions';
var CourseDetailsDiscussions = (_dec = connect(function (state) {
  return {
    course: state.courseDetails.course
  };
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(CourseDetailsDiscussions, _React$Component);
  var _super = _createSuper(CourseDetailsDiscussions);
  function CourseDetailsDiscussions() {
    _classCallCheck(this, CourseDetailsDiscussions);
    return _super.apply(this, arguments);
  }
  _createClass(CourseDetailsDiscussions, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {}, void 0, _CourseDetailsHeader || (_CourseDetailsHeader = /*#__PURE__*/_jsx(CourseDetailsHeader, {})), /*#__PURE__*/_jsx(Discussions, {
        courseId: _.get(this, 'props.course._id'),
        disableAutoload: true
      }));
    }
  }]);
  return CourseDetailsDiscussions;
}(React.Component)) || _class);
export { CourseDetailsDiscussions as default };